module.exports = __webpack_public_path__ + "static/media/mindfulness-for-financial-stress-large.bfe859e3.png";